import { render, staticRenderFns } from "./MenusPopup.vue?vue&type=template&id=0befbc34"
import script from "./MenusPopup.vue?vue&type=script&lang=js"
export * from "./MenusPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports